import { createFeatureSelector } from '@ngrx/store';
import { MarketingPlansModuleState } from '../reducers';

export const getMarketingPlansModuleState = createFeatureSelector<MarketingPlansModuleState>(
  'MarketingPlansModuleState',
);
